import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Courses from "../../api/Courses";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const CourseSectionS3 = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const coursesPerPage = 9;
    
    // Calculate pagination
    const totalPages = Math.ceil(Courses.length / coursesPerPage);
    const startIndex = (currentPage - 1) * coursesPerPage;
    const endIndex = startIndex + coursesPerPage;
    const currentCourses = Courses.slice(startIndex, endIndex);
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
    };

    return (
        <div className={`wpo-popular-area section-padding ${props.pClass}`}>
            <div className="container">
                <div className="wpo-popular-wrap">
                    <div className="row">
                        {currentCourses.map((course, aitem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={aitem}>
                                <div className="wpo-popular-single">
                                    <div className="wpo-popular-item">
                                        <div className="wpo-popular-img">
                                            <img src={course.cImg} alt="" />
                                            <div className="thumb">
                                                <span><i className="fi flaticon-star"></i> {course.ratting}</span>
                                            </div>
                                        </div>
                                        <div className="wpo-popular-content">
                                            <div className="wpo-popular-text-top">
                                                <ul>
                                                    <li><Link onClick={ClickHandler} to={`/course-single/${course.slug}`}>{course.authortitle}</Link></li>
                                                </ul>
                                                
                                            </div>
                                            <h2><Link onClick={ClickHandler} to={`/course-single/${course.slug}`}>{course.title}</Link>
                                            </h2>

                                            <div className="wpo-popular-text-bottom">
                                                <ul>
                                                    <li><i className="fi flaticon-reading-book"></i> {course.student} Students</li>
                                                    <li><i className="fi flaticon-agenda"></i> {course.lesson} Lesson</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    {/* Page Info */}
                    <div className="page-info text-center" style={{ marginBottom: '20px' }}>
                        <p>Showing {startIndex + 1}-{Math.min(endIndex, Courses.length)} of {Courses.length} courses (Page {currentPage} of {totalPages})</p>
                    </div>
                    
                    <div className="pagination-wrapper">
                        <ul className="pg-pagination">
                            <li>
                                <button 
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    aria-label="Previous"
                                    className={currentPage === 1 ? 'disabled' : ''}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: '8px 12px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                        opacity: currentPage === 1 ? 0.5 : 1
                                    }}
                                >
                                    <i className="fi ti-angle-left"></i>
                                </button>
                            </li>
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <li key={page} className={currentPage === page ? 'active' : ''}>
                                    <button 
                                        onClick={() => handlePageChange(page)}
                                        style={{
                                            background: currentPage === page ? '#007bff' : 'none',
                                            border: 'none',
                                            padding: '8px 12px',
                                            cursor: 'pointer',
                                            color: currentPage === page ? 'white' : 'inherit'
                                        }}
                                    >
                                        {page}
                                    </button>
                                </li>
                            ))}
                            <li>
                                <button 
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    aria-label="Next"
                                    className={currentPage === totalPages ? 'disabled' : ''}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: '8px 12px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                        opacity: currentPage === totalPages ? 0.5 : 1
                                    }}
                                >
                                    <i className="fi ti-angle-right"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseSectionS3;